module.exports = __webpack_public_path__ + "static/media/poster.028bf03e.jpg";